import React, { useEffect, useRef } from 'react';
import './CursorSpotlight.css';

const CursorSpotlight = () => {
  const spotlightRef = useRef(null);

  useEffect(() => {
    // Check if device supports fine hover/cursor
    const isTouchDevice = window.matchMedia('(pointer: coarse)').matches;
    if (isTouchDevice || !spotlightRef.current) return;

    let mouseX = window.innerWidth / 2;
    let mouseY = window.innerHeight / 2;
    let currentX = mouseX;
    let currentY = mouseY;
    let animationFrameId;

    const handleMouseMove = (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
    };

    const animate = () => {
      // Smooth lerp (linear interpolation) for trailing glow
      currentX += (mouseX - currentX) * 0.12;
      currentY += (mouseY - currentY) * 0.12;

      if (spotlightRef.current) {
        spotlightRef.current.style.transform = `translate3d(${currentX}px, ${currentY}px, 0)`;
      }

      animationFrameId = requestAnimationFrame(animate);
    };

    window.addEventListener('mousemove', handleMouseMove, { passive: true });
    animationFrameId = requestAnimationFrame(animate);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
    };
  }, []);

  return (
    <div className="cursor-spotlight-container" aria-hidden="true">
      <div ref={spotlightRef} className="cursor-spotlight-glow"></div>
    </div>
  );
};

export default CursorSpotlight;
